import { Modal, WebView } from '@components/1-atoms';
import React, { FC, useState } from 'react';

import { Button } from "@components/2-molecules";
import { Props as ButtonProps } from "@components/2-molecules/Buttons/Button";

import { EXPO_PUBLIC_PAYBOOKS_API_BASE } from "@lib/constants";
import { Platform, View } from 'react-native';
import { WebViewMessageEvent } from 'react-native-webview';

import { useAppAlerts } from '@lib/hooks/base/useAppAlerts';
import * as service from '@lib/service';
import * as utils from "@lib/utils";

const URL = `${EXPO_PUBLIC_PAYBOOKS_API_BASE}/plaid/`;

type Props = ButtonProps & {
  itemId?: string;
  children?: React.ReactNode;
  onDone?: (accounts: any) => void;
};


export const PlaidButton: FC<Props> = ({ itemId, children, onDone, ...props }) => {

  const alerts = useAppAlerts();

  const [webConfig, setWebConfig] = useState({ visible: false, key: Date.now() });

  const query = (itemId ? `?${new URLSearchParams({ itemId })}` : '');
  const uri = URL.concat(query);

  const _onPlaidLinkDone = () => {
    const msg = "Plaid link is successful.";

    alerts.alert('Plaid', msg,
      [
        { text: 'OK', onPress: utils.reloadApp },
      ]
    );
  };

  const _onMessage = (event: WebViewMessageEvent) => {
    let data = null;
    try {
      data = JSON.parse(event.nativeEvent.data);
    } catch (error) {
      console.error('Failed to parse message from WebView:', error);
    }

    (async () => {
      const axios = await service.getInstance();

      switch (data.eventName) {
        case 'success':
          // log public token
          console.log(data.publicToken, data.metadata);
          // retrieve public token
          const publicToken = data.publicToken;

          try {
            // request access token
            const syncResponse = await axios.post(uri, { data: publicToken });
            onDone?.(syncResponse);
            // close Plaid modal interface
            setWebConfig({ visible: false, key: Date.now() });
            // Reload the app to synch, refresh the bank / institution item account(s)
            _onPlaidLinkDone();
          } catch (error) {
            // onError?.(error);
            alert(`Plaid access token failed to synchronize:\n${JSON.stringify(error)}`);
            setWebConfig({ visible: false, key: Date.now() });
          }
          break;

        case 'exit':
          setWebConfig({ visible: false, key: Date.now() });
          break;

        default:
          console.log(data);
      }

    }
    )();
  };

  return (
    <View>
      <Button {...props} onPress={() => setWebConfig({ visible: true, key: Date.now() })}>
        {children || "LINK ACCOUNTS WITH PLAID"}
      </Button>

      <Modal
        key={webConfig.key}
        visible={webConfig.visible}
        bg={(Platform.OS === 'web') ? "#000000" : "#FFFFFF"}
        closable={false}
      >
        <WebView
          fullpage
          source={{ uri }}
          onMessage={_onMessage} />
      </Modal>
    </View>
  );

};



export default PlaidButton;
